export const SET_CURRENT_RESERVATION = 'SET_CURRENT_RESERVATION';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_ERROR_CODE = 'SET_ERROR_CODE';
